module.exports = __webpack_public_path__ + "static/logo-glenbeigh.f9b0406e.png";


//////////////////
// WEBPACK FOOTER
// /Users/terrymasher/Development/glenbeigh-ltd/src/static/img/logo-glenbeigh.png
// module id = 56
// module chunks = 3